var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionsBudgetEdited(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 60.32 60.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6e14;}.cls-2{fill:#d0dbfb;}.cls-3{fill:#948dbd;}.cls-4{fill:#281978;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    className: "cls-4",
    d: "m53.8,33.13c0-14.69-11.91-26.6-26.6-26.6-.2,0-.39.02-.58.03v5.93c.19,0,.38-.03.58-.03,11.42,0,20.67,9.26,20.67,20.67,0,.37-.04.74-.06,1.11h5.93c.02-.37.06-.73.06-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    className: "cls-2",
    d: "m26.62,12.48c-11.41.31-20.4,9.81-20.09,21.22.31,11.41,9.81,20.4,21.22,20.09,10.77-.29,19.5-8.81,20.07-19.56h-21.2V12.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    className: "cls-4",
    d: "m27.2,12.45c-.2,0-.39.02-.58.03v21.75h21.2c.02-.37.06-.73.06-1.11,0-11.42-9.26-20.67-20.67-20.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    className: "cls-3",
    d: "m27.2,12.45c-.2,0-.39.02-.58.03v21.75h21.2c.02-.37.06-.73.06-1.11,0-11.42-9.26-20.67-20.67-20.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    className: "cls-3",
    d: "m27.2,12.45c-.2,0-.39.02-.58.03v21.75h21.2c.02-.37.06-.73.06-1.11,0-11.42-9.26-20.67-20.67-20.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    className: "cls-1",
    d: "m44.37,34.23h-17.75v16.15c.19,0,.38.03.58.03,8.89,0,16.32-6.76,17.18-15.6v-.58Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsBudgetEdited);
export default __webpack_public_path__ + "static/media/Solutions_Budget-edited.bbb79d62dd8869db581ca2859eec0599.svg";
export { ForwardRef as ReactComponent };